import { render } from "./ListAccountsActionButtonsRenderer.vue?vue&type=template&id=67665f0f"
import script from "./ListAccountsActionButtonsRenderer.vue?vue&type=script&lang=js"
export * from "./ListAccountsActionButtonsRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__